import React from "react";
import { getImageBaseUrl } from "../services/s3-utils";

function QalortButton({
  type,
  children,
  className,
  loading,
  testid,
  disabled,
  ...rest
}) {
  return (
    <button
      disabled={disabled}
      data-testid={testid}
      className={`${className} flex items-center justify-center text-sm py-2 px-2 rounded-md h-[40px] ${
        type === "primary" && "border-pri bg-pri text-white"
      }
      ${disabled && "opacity-30 cursor-not-allowed"}
      `}
      {...rest}
    >
      <div className="one-liner">
        {loading ? (
          <img
            className="w-8"
            src={`${getImageBaseUrl}/assets/spinner.svg`}
            alt=""
          />
        ) : (
          <p className="p-sm mb-0 font-semibold">{children}</p>
        )}
      </div>
    </button>
  );
}

export default QalortButton;
